import React from 'react';
import PropTypes from 'prop-types';

import { ListItemAvatar as MUIListItemAvatar } from '@material-ui/core';

export const ListItemAvatar = props => <MUIListItemAvatar {...props} />;

ListItemAvatar.propTypes = {
  classes: PropTypes.object
};

export default ListItemAvatar;
